import { Checkbox } from '@HoudiniUI/Checkbox';
import { Field, FieldContent, FieldDescription, FieldLabel } from '@HoudiniUI/Field';
import { includeMeetingGuestsCheckboxStyles as styles } from './styles/IncludeMeetingGuestsCheckboxStyles';

interface IncludeMeetingGuestsCheckboxProps {
	id: string;
	checked: boolean;
	disabled: boolean;
	title: string;
	description: string;
	onChange: (checked: boolean) => void;
}

/**
 * Opts a meeting reminder step in to reaching the meeting's guests as well as the person who booked.
 */
export function IncludeMeetingGuestsCheckbox({
	id,
	checked,
	disabled,
	title,
	description,
	onChange,
}: IncludeMeetingGuestsCheckboxProps) {
	return (
		<Field orientation='horizontal' styles={[styles.field]}>
			<Checkbox id={id} checked={checked} disabled={disabled} onCheckedChange={value => onChange(value === true)} />
			<FieldContent>
				<FieldLabel htmlFor={id}>{title}</FieldLabel>
				<FieldDescription>{description}</FieldDescription>
			</FieldContent>
		</Field>
	);
}
